import script from "./ViewportBackground.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewportBackground.vue?vue&type=script&lang=ts&setup=true"

import "./ViewportBackground.vue?vue&type=style&index=0&id=50b03de8&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b03de8"]])

export default __exports__